import { createServerFn } from '@tanstack/react-start';
import { z } from 'zod';
import { db } from '@vibe/db/server';
import { webAdEdits } from '@generated/models';
import { requireStaff } from '@generated/server/staff.server';

/** Staff: every saved edit / deletion for the Web Ads page. */
export const getWebAdEdits = createServerFn({ method: 'POST' })
  .validator(z.object({ pass: z.string().optional() }))
  .handler(async ({ data }) => {
    await requireStaff(data.pass);
    const docs = await db.collection(webAdEdits).limit(500).get();
    return docs.map((d) => ({ id: d.id, adId: d.data.adId, html: d.data.html ?? null, hidden: d.data.hidden ?? false }));
  });

/** Staff: save new wording (html), clear it (html: null), or delete/restore (hidden) one ad. */
export const saveWebAdEdit = createServerFn({ method: 'POST' })
  .validator(z.object({
    pass: z.string().optional(),
    adId: z.string().min(1).max(120),
    html: z.string().max(400000).nullable().optional(),
    hidden: z.boolean().optional(),
  }))
  .handler(async ({ data }) => {
    await requireStaff(data.pass);
    // Strip scripts and inline event handlers; staff-only, but keep the stored markup inert.
    const clean = data.html == null ? data.html : data.html.replace(/<script[\s\S]*?<\/script>/gi, '').replace(/\son[a-z]+\s*=\s*("[^"]*"|'[^']*')/gi, '');
    const col = db.collection(webAdEdits);
    const existing = (await col.where('adId', '==', data.adId).limit(1).get())[0];
    const patch = { ...(clean !== undefined ? { html: clean } : {}), ...(data.hidden !== undefined ? { hidden: data.hidden } : {}), updatedAt: new Date().toISOString() };
    if (existing) await col.doc(existing.id).update(patch);
    else await col.add({ adId: data.adId, html: null, hidden: false, ...patch });
    return { ok: true };
  });
